import { render } from "./ManageTechnicalCommittee.vue?vue&type=template&id=083766f5&scoped=true"
import script from "./ManageTechnicalCommittee.vue?vue&type=script&lang=js"
export * from "./ManageTechnicalCommittee.vue?vue&type=script&lang=js"

import "./ManageTechnicalCommittee.vue?vue&type=style&index=0&id=083766f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083766f5"]])

export default __exports__